export let BASE_URL = {url: 'https://api.ingame-server.ru'};

// export let BASE_URL = {url: 'http://localhost:3000'};



export const API_URLS = {
  getAllMatches: '/matches/all',
  getMatch: '/matches/',
  setAllResults: '/matches/setAllResults',
  setMatchData: '/matches/setMatchData',
  // Правка атрибутов матча без заявки и событий — для быстрого
  // редактирования строки в матч-центре
  changeMatch: '/matches/changeMatch',
  // Частичное обновление нескольких матчей одним запросом (матч-центр)
  updateManyMatches: '/matches/updateMany',
  // Сброс матча, как в приложении: только состояние или всё (заявка, события, счёт)
  dropMatchState: '/matches/dropMatchState',
  dropMatch: '/matches/dropMatch',
  setMatchExtraData: '/matches/setMatchExtraData',
  setMatchBestPlayer: '/matches/setBestPlayer',
  unsetMatchBestPlayer: '/matches/unsetBestPlayer',

  login: '/users/login/admin',
  logout: '/users/logout',
  refreshTokens: '/users/refreshTokens',

  getMatchActiveApplication: '/matches/getRosterEvents',

  getAllStadiums: '/stadiums/getAllStadiums',

  getAllReferees: '/judges/getAllReferees',

  getAllAdminLeagues: '/leagues/allAdminLeagues',
  
  getAllClients: '/championships/allClients',

  // Управление лигами — чтение
  // Чемпионаты и лиги текущего админа одним ответом (см. LEAGUE_MANAGEMENT_BACKEND.md §1.1)
  getAdminLeagueStructure: '/leagues/adminLeagueStructure',
  getAllSeasons: '/leagues/seasons',
  getApplicationTemplates: '/clients/adminApplicationTemplates',
  getLeaguePartners: '/leagues/:leagueId/partners',
  // Спонсоры лиг (PARTNERS_BACKEND.md)
  getAdminPartners: '/partners/adminPartners',
  createPartner: '/partners/createPartner',
  updatePartner: '/partners/updatePartner',
  deletePartner: '/partners/deletePartner',
  setPartnerLeagues: '/partners/setPartnerLeagues',
  setLeaguePartners: '/leagues/setLeaguePartners',

  // Управление лигами — запись
  createChampionat: '/championships/createChampionat',
  updateChampionat: '/championships/updateChampionat',
  createLeague: '/leagues/createLeague',
  updateLeague: '/leagues/updateLeague',
  createLeagueSeason: '/leagues/createLeagueSeason',
  updateLeagueSettings: '/leagues/updateLeagueSettings',
  setSeasonTeams: '/leagues/setSeasonTeams',
  setSeasonGroups: '/leagues/setSeasonGroups',
  createApplicationTemplate: '/clients/createApplicationTemplate',

  // Капитанство игрока
  getPlayerAdminTeams: '/players/:playerId/adminTeams',
  setPlayerCaptain: '/players/setCaptain',

  getRoster: '/teams/:teamId/applications',
  // Представители команды — строки related_teams (номер, капитан, приоритет)
  getTeamRepresentatives: '/teams/:teamId/roster',
  connectPlayerToTeam: '/players/connectToTeam',

  getAdminTeams: '/teams/getAdminTeams',
  getAdminTeam: '/teams/getAdminTeam',
  addTeam: '/teams/addTeam',
  connectToLeague: '/teams/connectToLeague',
  
  getAdminClients: '/clients/getAdminClients',
  getAdminChampionships: '/championships/getAdminChampionships',
  getAdminLeagues: '/leagues/getAdminLeagues',
  getLeagueSeasons: '/leagues',  // Will add /:leagueId/adminLeagues dynamically
  
  getAvailableTeamApplications: '/teams/adminAvailableApplications',
  getTeamApplication: '/teams/getTeamApplicationQuery',
  getPlayerApplications:'/players/:playerId/adminApplicationsWithLeagues',
  declineApplication: '/teams/declineTeamApplication',
  acceptApplication: '/teams/acceptTeamApplication',

  searchPlayersByParams: '/players/search',
  // Batch-руты (FRONTEND_API_CHANGES / API_BATCH_REQUESTS)
  findPlayerDuplicates: '/players/findDuplicates',
  searchPlayersMany: '/players/searchMany',
  importPlayersToApplication: '/players/importToApplication',
  connectManyToApplication: '/players/connectManyToApplication',

  getBlackList: '/leagues/adminBlackList',
  getPlayerFromBlackList: '/leagues/adminBlackListPlayer',
  addToBlackList: '/leagues/adminBlackListAdd',
  changeBlackList: '/leagues/adminBlackListChange',
  deleteFromBlackList: '/leagues/adminBlackListDrop',

  // Инфографика (перенос вкладки "Публикации в соц сети" из приложения)
  // Рисующие руты. Дескриптор шаблона ссылается на них либо полным путём
  // в поле route, либо ключом отсюда в поле url — как в приложении
  social_pictures_live: '/social_pictures/live',
  social_pictures_mvp: '/social_pictures/mvp',
  social_pictures_preview: '/social_pictures/match_preview',
  social_pictures_preview_2: '/social_pictures/match_preview_2',
  social_pictures_preview_3: '/social_pictures/match_preview_3',
  social_pictures_preview_square: '/social_pictures/match_preview_square',
  social_pictures_preview_vip: '/social_pictures/match_preview_vip',
  social_pictures_preview_vip_2: '/social_pictures/match_preview_vip_2',
  social_pictures_tour_results: '/social_pictures/tour_results',
  social_pictures_tour_results_2: '/social_pictures/tour_results_2',
  social_pictures_tour_results_square: '/social_pictures/tour_results_square',
  social_pictures_tour_results_vip: '/social_pictures/tour_results_vip',
  social_pictures_tour_results_vip_v2: '/social_pictures/tour_results_vip_v2',
  social_pictures_tournament_table: '/social_pictures/tournament_table',
  social_pictures_tournament_table_vip: '/social_pictures/tournament_table_vip',
  social_pictures_tournament_table_vip_v2: '/social_pictures/tournament_table_vip_v2',
  social_pictures_chess_tournament_table: '/social_pictures/chess_tournament_table',
  social_pictures_playoff_table_one: '/social_pictures/playoff_table_one',
  soicial_pictures_playoff_table_four: '/social_pictures/playoff_table_four',
  soicial_pictures_get_top: '/social_pictures/get_top',
  soicial_pictures_get_top_2: '/social_pictures/get_top_2',
  soicial_pictures_get_top_vip: '/social_pictures/get_top_vip',
  soicial_pictures_get_top_vip_v2: '/social_pictures/get_top_vip_v2',
  social_pictures_tour_team: '/social_pictures/tour_team',
  social_pictures_tour_team_vip: '/social_pictures/tour_team_vip',
  social_pictures_tour_team_vip_v2: '/social_pictures/tour_team_vip_v2',
  social_pictures_match_cover_goal_vip: '/social_pictures/match_cover_goal_evo',
  social_pictures_match_cover_goal: '/social_pictures/match_cover_goal',

  // Каталог шаблонов и палитра
  getAllSocialPatterns: '/social_pictures/get_all',
  getSocialColors: '/social_pictures/fav_colors',
  // Справочники для параметров
  getLeagueStages: '/leagues/:leagueId/getLeagueStages',
  getLeagueMatches: '/leagues/:leagueId/matches',
  getMatchesByDate: '/leagues/matchesByDate',
  getLeagueGroupsList: '/leagues/:leagueId/get_groups',
  getLeagueGroupsWithIds: '/leagues/:leagueId/get_groups_with_ids',
  getLeaguePlayers: '/players/get_league_players',
  getMatchApplication: '/matches/getRosterEvents',

  // Расписание
  saveSchedule: '/leagues/saveSchedule',
  getTeamsByGroups: '/leagues/:leagueId/teamsByGroups',

};

export const leftTextFirstSlide = 
'Подключайте свою футбольную любительскую лигу на платформу мобильного приложения inGame! ' +
'Перенесём всю историю ваших чемпионатов. Постоянная техническая поддержка.'

export const rightTextFirstSlide = 
'Скачивайте приложение и смотрите статистику и информацию о матчах своей лиги! Оставляйте свои комментарии, впечатления и пожелания, с помощью вас мы сможем стать еще лучше.'

export const DOCUMENTS = {
  privacy: 'https://ingame-sports.ru/docs/soglashenie_o_konfidentsialnosti.docx',
  terms: 'https://ingame-sports.ru/docs/Polzovatelskoe_soglashenie.docx',
  personalData: 'https://ingame-sports.ru/docs/Politika_obrabotki_personalnykh_dannykh.docx',
  agreement: 'https://ingame-sports.ru/docs/Soglasie_na_obrabotku_pd_s.docx',
  cookies: 'https://ingame-sports.ru/docs/Politika_ispolzovaniya_failov_cookies.docx'
}


// Типы шаблонов инфографики. Значение уходит в /social_pictures/get_all,
// порядок и подписи повторяют приложение (src/constants/config.js:1409)
export const SOCIAL_PATTERN_TYPES = [
  { label: 'Все', value: 0 },
  { label: 'Результат/Превью', value: 1 },
  { label: 'Расписание/Результаты', value: 2 },
  { label: 'Турнирная таблица', value: 3 },
  { label: 'Топ 5', value: 4 },
  { label: 'Сборная тура', value: 5 },
  { label: 'Другое', value: 6 },
];

// Типы событий для шаблонов "Топ 5". Перенос из приложения (availableEvents)
export const SOCIAL_EVENT_TYPES = [
  { label: 'Бомбардиры', value: 1 },
  { label: 'Ассистенты', value: 2 },
  { label: 'Гол+Пас', value: 20 },
  { label: 'Желтые карточки', value: 3 },
  { label: 'Красные карточки', value: 4 },
  { label: 'Сухие матчи (ВРТ)', value: 21 },
  { label: 'Пропущенные голы (ВРТ)', value: 22 },
];

// Подписи для шаблонов MVP. Перенос из приложения (availableMvpLabels).
// На сервер уходит label, а не value — так же, как в приложении
export const SOCIAL_MVP_LABELS = [
  { label: 'MVP тура', value: 1 },
  { label: 'MVP матча', value: 2 },
  { label: 'Защитник тура', value: 3 },
  { label: 'Форвард тура', value: 4 },
  { label: 'Лучший вратарь турнира', value: 5 },
  { label: 'Лучший защитник турнира', value: 6 },
  { label: 'Лучший бомбардир турнира', value: 7 },
  { label: 'Лучший ассистент турнира', value: 8 },
  { label: 'Лучший игрок турнира', value: 9 },
  { label: 'Лучший полузащитик турнира', value: 10 },
];

// Палитры под конкретные наборы шаблонов. Какая палитра у какого шаблона —
// решает getSocialPalette в utilities/infographics.js (перенос getAvailbleEvoColors)
export const SOCIAL_PALETTES = {
  evo: ['#b30000', '#437700', '#00a8ca', '#e1e1e1', '#305c6d'],
  evo_new: ['#b30000', '#86a845', '#d9d9d9', '#ffd800'],
  evo_3: ['#b30000', '#86a845', '#ffd800', '#00a8ca', '#000000', '#8B00FF'],
  jfl: ['#1ad5c3', '#111e3c', '#e3ba39', '#abd7f9', '#5a2496'],
  evo_v2: ['#0185fc', '#fdce01', '#242424'],
  evo_v2_2: ['#fdce01', '#a7a7a7'],
  evo_v2_3: ['#0185fc', '#fdce01', '#242424', '#48f800', '#fe0010', '#9e02fe'],
  aksai: ['#000000', '#700070', '#006f00', '#000073', '#710000'],
  lfk: ['#00fff0', '#6a398f', '#4b1e03', '#614301', '#fffc00', '#8e0a4a',
    '#60ff00', '#ff0000', '#73098e', '#10c063', '#002b75', '#0c017a',
    '#c8c8c8', '#a2ba00', '#d1a200', '#740c0c', '#4d1841', '#5b0b8e',
    '#4200ff', '#007eff', '#125a5b', '#207053', '#a1a616', '#797979'],
};

// Базовые цвета шаблонов, которые админ может перекрасить.
// Перенос social_pictures_change_colors_helpers из приложения: ключ — id шаблона,
// значение — сколько цветов настраивается и какие они по умолчанию
export const SOCIAL_CHANGE_COLORS = {
  77: ['#cfa247', 'white'],
  78: ['#cfa247', 'white'],
  79: ['#cfa247', 'white'],
  80: ['#cfa247', 'white'],
  81: ['#cfa247', 'white'],
  82: ['#cfa247', 'white'],
  83: ['#cfa247', 'white', 'black'],
  84: ['#cfa247', 'white', 'black'],
  85: ['#cfa247', 'white', 'black'],
  86: ['#cfa247', 'white'],
  96: ['#cfa247', 'white', 'black'],
  98: ['#cfa247', 'white', 'black'],
  99: ['#cfa247', 'white', 'black'],
};

// Схемы расстановки для сборной тура. Перенос available_tour_teams_schemes
// из приложения: id схемы уходит на сервер в поле scheme
export const SOCIAL_TOUR_SCHEMES = [
  { id: 0, name: '11x11', data: [{ name: '4-4-2', id: 6 }, { name: '4-3-3', id: 7 }] },
  { id: 1, name: '8x8', data: [
    { name: '3-3-1', id: 0 }, { name: '3-2-2', id: 1 }, { name: '2-4-1', id: 8 },
    { name: '2-3-2', id: 9 }, { name: '2-2-3', id: 10 }, { name: '1-3-3', id: 12 },
    { name: '3-1-3', id: 13 },
  ] },
  { id: 2, name: '7x7', data: [{ name: '3-1-2', id: 2 }] },
  { id: 3, name: '6x6', data: [{ name: '2-1-2', id: 3 }] },
  { id: 4, name: '5x5', data: [{ name: '2-2', id: 4 }] },
  { id: 5, name: '4x4', data: [{ name: '1-2', id: 11 }] },
];

// Сколько игроков в линиях каждой схемы: [нападающие, полузащитники, защитники].
// Индекс массива = id схемы. Перенос available_tour_teams_schemes_helper —
// именно этот массив использует TeamChoose в приложении при раскладке слотов
export const SOCIAL_SCHEME_LINES = [
  [1, 3, 3], [2, 2, 3], [2, 1, 3], [2, 1, 2], [2, 0, 2], [1, 1, 2], [2, 4, 4],
  [3, 3, 4], [1, 4, 2], [2, 3, 2], [3, 2, 2], [2, 0, 1], [3, 3, 1], [3, 1, 3],
  [2, 3, 3], [2, 0, 2],
];

// Линии сборной тура: номер линии в поле index ("<линия>_<позиция>"),
// префикс подписи и название секции — как в приложении (TeamChoose)
export const SOCIAL_SCHEME_SECTIONS = [
  { line: 1, prefix: 'НАП', title: 'Нападающие' },
  { line: 2, prefix: 'ПЗЩ', title: 'Полузащитники' },
  { line: 3, prefix: 'ЗАЩ', title: 'Защитники' },
];

// Сетка плей-офф: раунды и слоты. Перенос структуры из PlayoffChoose
export const SOCIAL_PLAYOFF_ROUNDS = [
  { name: '1/8 (Слева)', slots: [1, 2, 3, 4] },
  { name: '1/8 (Справа)', slots: [5, 6, 7, 8] },
  { name: '1/4 (Слева)', slots: [9, 10] },
  { name: '1/4 (Справа)', slots: [11, 12] },
  { name: '1/2 (Слева)', slots: [13] },
  { name: '1/2 (Справа)', slots: [14] },
  { name: 'Финал', slots: [15] },
];
